import { RuleCategoryMap } from '../utils/maturityEvaluator';

export const rules: RuleCategoryMap = {
  Foundations: {
    description:
      'Baseline metadata and delivery signals that help teams discover and understand the component.',
    checks: [
      {
        name: 'Has description',
        check: "entity.metadata?.description",
        weight: 1,
        severity: 'minor',
        guidance: 'Add a concise description so others know what the component does.',
      },
      {
        name: 'Has tags',
        check: "entity.metadata?.tags?.length",
        weight: 1,
        severity: 'minor',
        guidance: 'Tag the component to improve discoverability and filtering.',
      },
      {
        name: 'Has links',
        check: "entity.metadata?.links?.length",
        weight: 1,
        severity: 'minor',
        guidance: 'Add relevant links (runbooks, dashboards, repos) to the catalog manifest.',
      },
      {
        name: 'Has tech docs',
        check: "entity.metadata.annotations?.['backstage.io/techdocs-ref']",
        weight: 2,
        severity: 'major',
        guidance: 'Configure TechDocs so teams can self-serve documentation.',
      },
      {
        name: 'Has CI pipeline',
        check: "entity.metadata.annotations?.['ci/pipeline']",
        weight: 2,
        severity: 'major',
        guidance: 'Advertise the primary CI pipeline via the ci/pipeline annotation.',
      },
    ],
  },
  Observability: {
    description:
      'Monitoring hooks that surface health signals and alert the team when things go wrong.',
    checks: [
      {
        name: 'Has error tracking',
        check: "entity.metadata.annotations?.['glitchtip/errors-check-url']",
        weight: 2,
        severity: 'major',
        guidance: 'Connect the service to the GlitchTip error tracker to capture exceptions.',
      },
      {
        name: 'Has uptime monitor',
        check: "entity.metadata.annotations?.['glitchtip/health-check-url']",
        weight: 3,
        severity: 'critical',
        guidance: 'Expose an uptime monitor so on-call can detect outages quickly.',
      },
    ],
  },
  Security: {
    description:
      'Security scanning and code quality protections that keep the component safe in production.',
    checks: [
      {
        name: 'Has SonarQube',
        check: "entity.metadata.annotations?.['sonarqube/project-id']",
        weight: 2,
        severity: 'major',
        guidance: 'Link a SonarQube project to surface security and code quality issues.',
      },
    ],
  },
};
